<i18n src="../../../lib/i18n/product/locales.json"></i18n>
<template>
    <div class="iadapter">
        <navbar :transparent="isTransparent"></navbar>
        <section class="iadapter-banner">
            <div class="iadapter-banner-tile">
                <h1>{{$t('iadapter_banner_tittle')}}</h1>
                <p>{{$t('iadapter_banner_content')}}</p>
            </div>
        </section>
        <section>
            <row class="max_width iAdapter_buy_page">
                <i-col :lg="12" :md="12" :sm="24" :xs="24">
                    <img src="../../../assets/store/iadapter/iAdapter_1.png" width="90%"/>
                </i-col>
                <i-col :lg="12" :md="12" :sm="24" :xs="24" class="iAdapter_buy_page2">
                    <h1>{{$t('iadapter_buy_tittle')}}</h1>
                    <span>${{goods_info.goods_price}}</span>
                    <p>{{$t('iadapter_buy_content')}}</p>
                    <buy :id="parseInt($route.query.id)" :maxCount="parseInt(goods_info.store_count)"></buy>
                </i-col>
            </row>
        </section>

        <section>
            <row class="max_width iAdapter_detail_1">
                <i-col :span="24">
                    <h1>{{$t('iadapter_detail_advantage')}}</h1>
                    <p>{{$t('iadapter_detail_advantage_content')}}</p>
                    <img src="../../../assets/store/iadapter/iadapter_4.png" width="90%"/>
                </i-col>
            </row>
        </section>
        <section style="background-image: linear-gradient(44deg, #E7E8E9 0%, #FAFBFB 72%, #FDFDFD 82%, #FFFFFF 100%);">
            <row class="max_width iAdapter_detail_1">
                <i-col :span="24">
                    <h1>{{$t('iadapter_detail_advantage2')}}</h1>
                    <p>{{$t('iadapter_detail_advantage_content2')}}</p>
                    <img src="../../../assets/store/iadapter/iadapter_5.png" width="90%"/>
                    <div class="iAdapter_detail_1_foot">
                        {{$t('iadapter_detail_advantage_content2-1')}}<br/>{{$t('iadapter_detail_advantage_content2-2')}}
                    </div>
                </i-col>
            </row>
        </section>
        <section>
            <row class="max_width iAdapter_detail_1">
                <i-col :span="24">
                    <h1>{{$t('iadapter_detail_advantage3')}}</h1>
                    <p>{{$t('iadapter_detail_advantage_content3')}}</p>
                    <img src="../../../assets/store/iadapter/iadapter_6.png" width="90%"/>
                </i-col>
            </row>
        </section>
        <section style="background-image: linear-gradient(44deg, #E7E8E9 0%, #FAFBFB 72%, #FDFDFD 82%, #FFFFFF 100%);">
            <row class="max_width iAdapter_detail_1">
                <i-col :span="24">
                    <h1>{{$t('iadapter_detail_advantage4')}}</h1>
                    <p>{{$t('iadapter_detail_advantage_content4-1')}}
                        <br/>{{$t('iadapter_detail_advantage_content4-2')}}</p>
                    <img src="../../../assets/store/iadapter/iadapter_7.png" width="90%" style="width: 550px;max-width: 90%;"/>
                </i-col>
            </row>
        </section>
        <section>
            <row class="max_width iAdapter_detail_1">
                <i-col :span="24">
                    <h1>{{$t('iadapter_detail_advantage5')}}</h1>
                    <p>{{$t('iadapter_detail_advantage_content5-1')}}</p>
                    <img src="../../../assets/store/iadapter/iadapter_8.png" width="95%" style="width: 100%;max-width: 95%;" v-if="type === 'a' "/>
                    <img src="../../../assets/store/iadapter/iadapter_8_en.png" width="95%" style="width: 100%;max-width: 95%;" v-else-if="type === 'b'" />
                    <img src="../../../assets/store/iadapter/iadapter_8_fanti.png" width="95%" style="width: 100%;max-width: 95%;" v-else-if="type === 'c'"/>
                </i-col>
            </row>
        </section>
        <section id="iAdapter_detail">
            <row class="max_width iAdapter_detail_1">
                <i-col :span="24">
                    <h1 style="color: white">{{$t('iadapter_detail_advantage6')}}</h1>
                    <p  style="color: white">{{$t('iadapter_detail_advantage_content6-1')}}</p>
                </i-col>
            </row>
        </section>
        <section style="background-image: linear-gradient(44deg, #E7E8E9 0%, #FAFBFB 72%, #FDFDFD 82%, #FFFFFF 100%);">
            <row class="iAdapter_detail" style="max-width: 700px;margin: 0 auto;">
                <i-col :lg="12" :md="12" :sm="24" :xs="24">
                    <div class="iAdapter_detail_group">
                        <ul>
                            <li class="detail_title">{{$t('details_page_product_parameters')}}</li>
                            <li class="detail_dec">{{$t('iadapter_detail_1')}}</li>
                            <li class="detail_dec">{{$t('iadapter_detail_2')}}</li>
                            <li class="detail_dec">{{$t('iadapter_detail_3')}}</li>
                            <li class="detail_dec">{{$t('iadapter_detail_4')}}</li>
                            <li class="detail_dec">{{$t('iadapter_detail_5')}}</li>
                            <li class="detail_dec">{{$t('iadapter_detail_6')}}</li>
                            <li class="detail_dec">{{$t('iadapter_detail_7')}}</li>
                            <li class="detail_dec">{{$t('iadapter_detail_8')}}</li>
                            <li class="detail_dec">{{$t('iadapter_detail_9')}}</li>
                        </ul>
                    </div>
                </i-col>
                <i-col :lg="12" :md="12" :sm="24" :xs="24" class="iAdapter_buy_page2">
                    <img src="../../../assets/store/iadapter/iadapter_3.png" width="70%"/>
                </i-col>
            </row>
        </section>
        <section style="max-width: 1200px;margin: 0 auto;text-align: left;width: 100%;margin: 0 auto;padding: 30px 10px;font-size: 16px;color: #5E6D82;">
            <p style="color: #0084ff">{{$t('shopping_notes')}}</p>
            <p>{{$t('shopping_notes_tip')}}</p>
            <guess></guess>
        </section>
    </div>
</template>

<script>
    import navbar from '../../Common/Navbar.vue'
    import guess from '../../Profiler/Common/Guess.vue'
    import buy from '../../Common/Buy.vue'
    import Signature from '../../../lib/Signature'

    export default {
        data () {
            return {
                isTransparent: true,
                goods_info:{},
                type:'b'
            }
        },
        components: {
            navbar,
            guess,
            buy
        },
        created () {
            let module = 'index.php/index/goods/goodsinfo'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$i18n.locale
            data.goods_id = this.$route.params.id || this.$route.query.id
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    this.goods_info = resp.data.data.goods_info
                }
            }.bind(this))
            data.lang = this.$i18n.locale
            if(data.lang === 'en-US'){
                this.type = 'b'
            }else if (data.lang === 'zh-HK'){
                this.type = 'c'
            }else if (data.lang === 'zh-CN'){
                this.type = 'a'
            }
        }
    }
</script>
<style lang="scss" scoped>
    .iadapter{
        width: 100%;
        /*font-family: PingFangSC-Regular;*/
        .iadapter-banner{
            background-image: url('../../../assets/store/iadapter/iadapter_banner.jpg');
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            height: 100vh;
            max-height:760px;
            .iadapter-banner-tile{
                padding-top: 10%;
                h1{
                    /*font-family: PingFangSC-Regular;*/
                    font-size: 32px;
                    color: #1F2D3D;
                    font-weight: 500;
                    margin: 10px auto;
                }
                p{
                    font-size: 20px;
                    color: #1F2D3D;
                }
            }
        }
        .iAdapter_buy_page{
            padding:4% 0;
            img{
                max-width: 260px;
                margin-top: 10%;
                padding: 0 20px;
            }
            .iAdapter_buy_page2{
                text-align: left;
                h1{
                    font-size: 32px;
                    color: #1F2D3D;
                    font-weight: 500;
                }
                span{
                    font-size: 32px;
                    color: #0084FF;
                    margin-bottom: 10px;
                }
                p{
                    font-size: 16px;
                    color: #1F2D3D;
                }
            }
        }
        .iAdapter_detail{
            padding: 10% 0;
            .iAdapter_detail_group{
                width: 100%;
                text-align: right;
                ul{
                    max-width: 400px;
                    margin-top: 20px;
                    text-align: left;
                    .detail_title{
                        /*font-family: PingFangSC-Semibold;*/
                        font-size: 22px;
                        color: #1F2D3D;
                        margin-bottom: 20px;
                    }
                    .detail_dec{
                        /*font-family: PingFangSC-Regular;*/
                        font-size: 16px;
                        color: #1F2D3D;
                    }
                }
            }
            img{
                max-width: 355px;
            }
        }
        .iAdapter_detail_1{
            padding: 5% 20px;
            h1{
                /*font-family: PingFangSC-Semibold;*/
                font-size: 22px;
                color: #1F2D3D;
                margin-bottom: 2%;
            }
            p{
                /*font-family: PingFangSC-Regular;*/
                font-size: 16px;
                color: #5E6D82;
                padding-bottom: 5%;
                max-width: 580px;
                margin: 0  auto;
            }
            img{
                max-width: 620px;
            }
            .iAdapter_detail_1_foot{
                font-size: 16px;
                color: #5E6D82;
                margin-top: 10px;
            }

        }
        #iAdapter_detail{
            background: url("../../../assets/store/iadapter/iadapter_9.jpg");
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            max-height:768px;
            min-height:400px;
            .iAdapter_detail_1{
                padding-top: 3%;
                padding-bottom: 30%;
            }
        }
        @media only screen and (max-width: 992px) {
            .iadapter-banner{
                .iadapter-banner-tile{
                    padding-top: 20%;
                }
            }
            .iAdapter_buy_page{
                .iAdapter_buy_page2{
                    width: 100%;
                    padding: 0 20px;
                    text-align:center
                }
            }
            .iAdapter_detail{
                .iAdapter_detail_group{
                    ul{
                        margin: 0 auto;
                        padding-left: 30px;
                        padding-bottom: 3%;
                    }
                }
            }
        }
        @media only screen and (max-width: 768px) {
            .iAdapter_buy_page {
                .iAdapter_buy_page2{
                h1{
                    font-size: 30px;
                }
                }
            }
        }

        @media only screen and (max-width: 414px) {
        .iadapter-banner {
            .iadapter-banner-tile {
                    p{
                        max-width: 300px;
                        margin: 0 auto;
                    }
                }
            }
            #iAdapter_detail{
                background: url("../../../assets/home/new_home/iAdapter@2x.jpg");
                height: 90vh;
                div{
                    padding-top: 70%;
                }
            }
        }


    }
</style>



// WEBPACK FOOTER //
// iAdapter.vue?b16e30b2